<div *ngIf="!isServerError && !firstLoading" class="calendar-navigation">
  <button *ngIf="showCurrentDayButton || mobile" class="no-style current-day" mwlCalendarToday [(viewDate)]="viewDate" (click)="todayBtnClick()">
    <mat-icon [svgIcon]="'calendar-current'" class="square-icon current-day-icon"></mat-icon>
    <span *ngIf="currentDayButtonLabel" class="current-day-label d-phone-none">{{ currentDayButtonLabel }}</span>
  </button>

  <div class="month-selector">
    <button class="no-style prev" mwlCalendarPreviousView [(viewDate)]="viewDate" [view]="'month'" (click)="monthChange('prev')">
      <mat-icon [svgIcon]="'prev'" class="square-icon arrow-icon"></mat-icon>
    </button>
    {{ viewDate | date: 'MMMM yyy' }}
    <span *ngIf="LocalizationService.showHebrewElements()">
      /
      <span class="d-not-phone-none">{{ viewDate | hebrewMonth }}</span>
      <span class="d-phone-none">{{ viewDate | hebrewMonth }}</span>
    </span>   
    <button class="no-style next" mwlCalendarNextView [(viewDate)]="viewDate" [view]="'month'" (click)="monthChange('next')">
      <mat-icon [svgIcon]="'next'" class="square-icon arrow-icon"></mat-icon>
    </button>
  </div>
</div>

<div *ngIf="!isServerError && !firstLoading" class="filters-wrap d-phone-none">
  <div *ngIf="filtersLabel" class="filters-label">{{ filtersLabel }}:</div>
  <div class="filters">
    <mat-checkbox
      *ngFor="let filter of typeFilterItems"
      class="radio-view"
      [ngStyle]="{'--control-color': FiltersColorHelper.getStyleColor(filter.color)}"
      [value]="getStringEnumForCheckbox(filter.valueArr!)"
      [checked]="filter.checked"
      (change)="typeChange($event)"
    >
      {{ filter.label }}
    </mat-checkbox>
  </div>
</div>

<div *ngIf="showMobileFilters && !isServerError && !firstLoading" class="mobile-filters d-not-phone-none">
  <app-filter-item
    #typeFilter
    [filterTitle]="filtersLabel"
    [filterItems]="typeFilterItems"
    [multi]="true"
    (setValue)="mobileTypeFilterChange($event)"
    (showFilterMobileDropdown)="closeOpenMobileFilter(true)"
    (closeFilterMobileDropdown)="closeOpenMobileFilter(false)"
  />
</div>

<div *ngIf="!isServerError && !firstLoading" class="calendar-component-wrap" [@openClose]="opened ? 'opened' : 'closed'">
  <mwl-calendar-month-view
    class="calendar-component"
    [viewDate]="viewDate"
    [refresh]="refresh"
    [events]="events"
    [cellTemplate]="cellTemplate"
    [headerTemplate]="headerTemplate"
  ></mwl-calendar-month-view>
</div>

<div *ngIf="!isServerError && !firstLoading" class="open-calendar-box">
  <button class="no-style" (click)="toggleCalendarState()">
    <mat-icon [svgIcon]="opened ? 'arrow-up-2' : 'arrow-down-2'" class="square-icon open-calendar-icon"></mat-icon>
  </button>
</div>
<script src="https://apis.google.com/js/platform.js" async defer></script>

<ng-template #cellTemplate let-day="day" let-locale="locale">
  <ng-container *ngIf="!isLoading">
    <app-event-details
      *ngIf="currentEvent && currentDate === day.date"
      [event]="currentEvent"
      [color]="FiltersColorHelper.getPrimaryColor(currentEvent.eventData.calenderDataType, studentCalendarFilters)"
      (close)="closeEvent()"
      [notificationsHeaderText]="notificationsHeaderText"
    />

    <div class="d-phone-none desktop-cal-day-wrap">
      <div class="cal-cell-top">
        <span class="cal-day-number">
          {{ day.date | calendarDate:'monthViewDayNumber': locale }}
        </span>
      </div>

      <div class="cal-events" *ngIf="day.events.length > 0">
        <ng-container *ngFor="let event of day.events">
          <div class="cal-event-wrap">
            <div
              class="cal-event"
              [ngStyle]="{ 'background-color': FiltersColorHelper.getSecondaryColor(event.eventData.calenderDataType, studentCalendarFilters) }"
              [ngClass]="event?.cssClass"
              (click)="openEvent(event, day.date)"
            >
              <strong *ngIf="!isTimeEmpty(event.eventData.date)">{{ event.eventData.date.replace('Z', '') | date: 'HH:mm' }}</strong>
              {{ event.title }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <app-dropdown
      class="day-dropdown"
      panelClass="events-dropdown-panel"
      [close]="closeEvents"
      [disabled]="disableDetailsShowing"
    >
      <div
        app-dropdown-trigger
        class="cal-day-wrap"
        (click)="dayClicked(day.date)"
      >
        <span class="cal-day-number">
          {{ day.date | calendarDate:'monthViewDayNumber': locale }}
        </span>
        <div *ngIf="day.events.length" class="cal-day-point"></div>
      </div>

      <ng-container app-dropdown-content>
        <label *ngIf="LocalizationService.showHebrewElements()" class="cal-events-title">{{ day.date | date: 'dd.MM.yyyy' }} | {{ viewDate | hebrewMonth }}</label>
        <label *ngIf="!LocalizationService.showHebrewElements()" class="cal-events-title">{{ day.date | date: 'dd.MM.yyyy' }}</label>

        <div class="cal-events overflow-auto">
          <app-event
            *ngFor="let event of day.events"
            [event]="event" [color]="FiltersColorHelper.getPrimaryColor(event.eventData.calenderDataType, studentCalendarFilters)"
            (open)="openEvent(event, day.date)"
          ></app-event>
        </div>
      </ng-container>
    </app-dropdown>
  </ng-container>
  <ng-container *ngIf="isLoading">
    <app-skeleton class="day-cell skeleton" [borderRadius]="0"/>
  </ng-container>
</ng-template>

<ng-template #headerTemplate let-days="days" let-locale="locale">
  <div class="cal-cell-row cal-header">
    <div class="cal-cell" *ngFor="let day of days; let i = index">
      <span *ngIf="LocalizationService.showHebrewElements()" class="full-name">{{ day.date | calendarDate:'weekViewColumnHeader': locale | slice : 3 }}</span>
      <span *ngIf="LocalizationService.showHebrewElements()" class="short-name">{{ i | hebrewDayName }}</span>
      <span *ngIf="!LocalizationService.showHebrewElements()" class="full-name">{{ day.date | calendarDate:'weekViewColumnHeader': locale }}</span>
      <span *ngIf="!LocalizationService.showHebrewElements()" class="short-name">{{ i | shortDayOfWeek: true }}</span>
    </div>
  </div>
</ng-template>

<div class="catalog" *ngIf="!mobileMode && firstLoading && !isServerError">
  <div class="catalog__content">
    <div class="preloader--mini">
      <div class="preloader__icon">
          <img alt="" height="50" loading="lazy" src="Content/Images/icons/preloader.png?format=webp" width="50">
        </div>
    </div>
  </div>
</div>

<app-timeout-error-message *ngIf="isServerError"></app-timeout-error-message>

<ng-container *ngIf="firstLoading">
  <app-skeleton [height]="420"></app-skeleton>
</ng-container>